var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rb-title"},[_c('span',[_vm._v(_vm._s(_vm.title)+" "),(_vm.litter)?_c('span',{staticClass:"litter"},[_vm._v(_vm._s(_vm.litter))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }